import React from "react";

import { Blank, Icon } from "grommet-icons";

export const GithubIcon: Icon = (props) => (
  <Blank {...props} viewBox="0 0 48 48">
    <path
      fill="#000"
      d="M24 0C10.748 0 0 11.018 0 24.607c0 10.872 6.876 20.095 16.414 23.35 1.198.227 1.586-.536 1.586-1.184v-4.58c-6.676 1.488-8.066-2.904-8.066-2.904-1.092-2.844-2.666-3.601-2.666-3.601-2.178-1.528.166-1.495.166-1.495 2.41.172 3.678 2.537 3.678 2.537 2.14 3.76 5.614 2.674 6.984 2.044.214-1.59.836-2.676 1.524-3.289-5.33-.626-10.934-2.736-10.934-12.162 0-2.688.938-4.882 2.472-6.605-.248-.621-1.07-3.125.234-6.512 0 0 2.016-.66 6.602 2.522A22.488 22.488 0 0 1 24 11.899c2.04.01 4.094.283 6.012.829 4.582-3.183 6.594-2.522 6.594-2.522 1.306 3.39.484 5.893.236 6.512 1.54 1.723 2.47 3.919 2.47 6.605 0 9.451-5.614 11.532-10.958 12.141.86.763 1.646 2.26 1.646 4.557v6.752c0 .654.384 1.423 1.602 1.181C41.132 44.696 48 35.474 48 24.607 48 11.017 37.254 0 24 0Z"
    />
  </Blank>
);
